
import {activeViewClass, AutocompleteError, copyToClipboard, cvErrors, closeDropDown, NewPageStyle, PageStyle, Image, DropboxChooser, GoogleChooser,
  EXTENSION_COMMON, Link, onApplyClick, Button, ButtonStyle, fb, applyJobInitialValues, handleFormSubmit, onCancel,
  otherErrors, onFileChange, twitter,linkedin, NextServerCookies, JobCommon, useRouter, useRef, useState, useTranslation,
  useEffect, updateApplicationData, viewDescription, viewJobValidation, updatePage, Tooltip, Loading, ErrorPages, without_cv_condition_passes,
  CustomToastrAction, DuplicateEmailModal, Header, Footer, CustomizeCareerAction, redirectToCarrerPage, GoogleFontLoader, QUESTION_TYPES, validAnswers, DefaultCheckbox, HoverCheckbox, CheckedCheckbox} from '@/imports-files/pages/career/view-job';

import parse from 'html-react-parser';
import {FacebookShareButton, TwitterShareButton, LinkedinShareButton} from "react-share";
import HelmetMetaData from '@/pages/helmet_meta_data';
import { InputError, InputText, Form, FormikControl, Formik, FormStyle, Field} from "@/imports-files/pages/clients/jobs/new";
import {Checkbox} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ApplyDropzone from '@/components/apply_dropzone';
import Deviceicon from 'public/icons/device.svg';
import BackArrow from 'public/icons/apply-job/back.svg';
import LocationIcon from 'public/icons/apply-job/location.svg';
import TimeLineWeekIcon from 'public/icons/apply-job/timeline-week.svg';
import BlankSheetIcon from 'public/icons/apply-job/blanksheets.svg';
import CoinsIcon from 'public/icons/apply-job/coins.svg';
import ShareIcon from 'public/new-icons/share.svg';
import FacebookIcon from 'public/icons/apply-job/facebook.svg';
import TwitterIcon from 'public/icons/apply-job/twitter.svg';
import LinkedInIcon from 'public/icons/apply-job/linkedIn.svg';
import DropdownIcon from 'public/icons/apply-job/dropdown.png';

import Dropboxicon from 'public/icons/dropbox.svg';
import Driveicon from 'public/icons/drive.svg';
import Clipboard from 'public/icons/clipboard.svg';
import Congrats from '@/components/congrats';
import Error from 'public/icons/error_exclamation.svg';
import Li from 'public/icons/linkedicon.png';
import {PrivacyPolicyDetails} from "@/components/privacy-policy-details";
import Head from 'next/head'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Modal from '@/components/common-modal/modal';

function ViewJob({ job, candidate_details, activeTab, source, status_code })
{
const {t, i18n}                                   =   useTranslation()
const url                                         =   (typeof window != "undefined") ? window?.location?.href : ''
const router                                      =   useRouter();
if(status_code != 200) return new ErrorPages().renderPage(status_code, router)
const formRef                                     =   useRef();
const job_id                                      =   job.slug
const dropdownRef                                 =   useRef(null);
const [isActive, setIsActive]                     =   useState(false);
const [cvErrorMessage, setCvErrorMessage]         =   useState('');
const [otherErrorMessage, setOtherErrorMessage]   =   useState('');
const [confirmModal, setConfirmModal]             =   useState(false);
const [formState, setFormState]                   =   useState('confirm');
const [clipboardMessage, setClipBoardMessage]     =   useState('Copy To Clipboard');
const [fileCount, setFileCount]                   =   useState(0);
const [isApplied, setApplied]                     =   useState(false);
const [activeView, setActiveView]                 =   useState(activeTab);
const [showLoader, setShowLoader]                 =   useState(false);
const [isDisabled, setIsDisabled]                 =   useState(false);
const [privacyPolicy, setPrivacyPolicy]           =   useState(false);
const [duplicateEmail, setDuplicateEmail]         =   useState({state: false, message: ''})
const [checked, setChecked]                       =   useState(true);
const [tabIndex, setTabIndex]                     =   useState(activeView == 'job' ? 0 : 1);
const [fonts, setFonts] = useState([])
const [documentLoaded, setDocumentLoaded] = useState(false);
const customizeCareerAction = new CustomizeCareerAction({formRef: {current: {values: job.career_page}}});
const job_script = job.google_for_job_data
const BlueLogo = '/images/logo/Bluelogo.png'
const header_values = job.career_page
header_values.logo_url = job.client_logo || BlueLogo
// if(Object.keys(candidate_details).length > 0)
// {
//   INITIAL_VALUES.job_application.name = candidate_details["name"]
//   INITIAL_VALUES.job_application.email = candidate_details["email"]
//   INITIAL_VALUES.job_application.contact_no = candidate_details["contact_no"]
//   INITIAL_VALUES.job_application.resume_attributes.file_name = candidate_details["cv_filename"]
//   INITIAL_VALUES.job_application.cv_library_filename = candidate_details["cv_filename"]
//   INITIAL_VALUES.job_application.cv_library_token = candidate_details["token"]
// }
// INITIAL_VALUES.job_application.without_cv = job["without_cv"]

const onClick = () => setIsActive(!isActive);
useEffect(() => {
if (typeof document != "undefined")
{
// let existingScript = document.getElementById('indeed-apply-script');
let existingGoogleScript = document.getElementById('google-job-script');
if(!existingGoogleScript && job_script){
  const google_script = document.createElement('script')
  google_script.type = "application/ld+json"
  google_script.text = JSON.stringify(job_script)
  document.body.appendChild(google_script)
}

// if(!existingScript)
// {
//   const script = document.createElement('script')
//   script.src = 'https://apply.indeed.com/indeedapply/static/scripts/app/bootstrap.js'
//   script.async = true
//   document.body.appendChild(script)
// }
const pageClickEvent = (e) => {
  // If the active element exists and is clicked outside of
  if (dropdownRef.current !== null && !dropdownRef.current.contains(e.target)) {
    setIsActive(!isActive);
  }
};
// if (isApplied) {
//   if(document.getElementsByClassName('indeed-apply-popup-bg').length > 0){
//     let observer1 = new MutationObserver((mutationRecords) => updatePage(mutationRecords, router, job.title));
//     observer1.observe( document.getElementsByClassName('indeed-apply-popup-bg')[0], { attributes: true, attributeFilter: ['style'], attributeOldValue: true } );
//   }
// }
// If the item is active (ie open) then listen for clicks
if (isActive)
{
  window.addEventListener('click', pageClickEvent);
}
return () => {
  window.removeEventListener('click', pageClickEvent);
}
}

}, [isActive, isApplied]);

useEffect(()=>{
    // job?.client_primary_color ? document.querySelector('.viewJobHeader').style.backgroundColor = job.client_primary_color : '';
    // the length condition is for the application coming from the job board
    // (Object.keys(router.query).length > 0 && router.query.q != 'desc')|| router.query.q == 'apply' ? setTabIndex(1) : '';
    if(job?.career_page?.id) setFonts(customizeCareerAction.listofAllFonts({values: job.career_page}));
    setDocumentLoaded(true)
    setTimeout(() => {
            let iframeElement = document.getElementById('iframeID')
              if(iframeElement) iframeElement.height = iframeElement.contentDocument.body.scrollHeight + 50 + 'px'
            }, 500)
},[])
useEffect(() => {
  if(job)
  {
    let langauge = job.language || "en"
    if(i18n.language !== langauge){
      i18n.changeLanguage(langauge);
    }
  }
}, [])

function viewJobPrivacyPolicy(){
  if(job.privacy_policy)
  return <a onClick={()=> setPrivacyPolicy(true)}>Privacy Policy</a>
  else
  return 'Privacy Policy'
}

const addTargetToLinks = (htmlContent) => {
  return htmlContent.replace(/<a(?![^>]*target=)/g, '<a target="_blank"');
};

function description_with_style(job, customizeCareerAction){
  const indigoColor = '#00325A'
  if(job?.career_page?.id){
    let labelStyle = job?.career_page?.id ? customizeCareerAction.labelStyle({values: job.career_page}) : null;
    let fontFamily = customizeCareerAction.loadSubTextFont({values: job.career_page})
    let fontFamilyLink = customizeCareerAction.createLink([fontFamily])
    return `<link rel='stylesheet' href=${fontFamilyLink}><style>body {color: ${labelStyle.color}; font-family: ${fontFamily} !important; }</style>`
  }
  else{
    return `<style>body {color: ${indigoColor};}</style>`
  }
}

function setFontStyle(job, customizeCareerAction){
  const style = {}
  if(job?.career_page?.id){
    let labelStyle = customizeCareerAction.labelStyle({values: job.career_page})
    style.fontFamily = customizeCareerAction.loadSubTextFont({values: job.career_page})
    style.color = labelStyle.color
  }
  return style
}

const styledDescription = `
  <style>
    body {
      font-family: Whitney, sans-serif;
    }
  </style>
`;

function displayStyle(documentLoaded){
  return documentLoaded ? { display: 'block'} : {display: 'none'}
}

function renderQuestions(formik, question, question_index) {
  let last_index = question.question_options_attributes.length > 0 ? (question.question_options_attributes.length - 1) : 0
  switch(question.question_type_name){
  case QUESTION_TYPES.SINGLE_LINE:
    return <FormikControl
      control       =   "input"
      type          =   "text"
      name          =   {`job_application.screening_answers_attributes.${question_index}.text`}
      className     =   {NewPageStyle.ApplyForm__InputField}
      formik        =   {formik}
      style         =   {InputError(formik, `job_application.screening_answers_attributes.${question_index}.text`)}
      custom_class  =   {"form_custom_error"}
      maxLength     =   {250}
    />
    break;
  case QUESTION_TYPES.MULTIPLE_LINE:
    return <FormikControl
            control       =   "customtextarea"
            type          =   "text"
            rows          =    "7"
            name          =   {`job_application.screening_answers_attributes.${question_index}.text`}
            className     =   {`${NewPageStyle.ApplyForm__InputField} ${NewPageStyle.ApplyForm__Textarea}`}
            formik        =   {formik}
            style         =   {InputError(formik, `job_application.screening_answers_attributes.${question_index}.text`)}
            custom_class  =   {"form_custom_error"}
            maxLength     =   {750}
          />
    break;
  case QUESTION_TYPES.YES_NO:
    return <div className={`ViewJobRadio ScreeningQuestions WrapperRadio w100 align-items-start flex-column`}>
       {question.question_options_attributes.map((question_option, question_option_index) =>
        <label className={`Dpflex WrapperRadioContainer WrapperRadiocheckmarkfont ${question_option_index == last_index ? 'mb0' : 'mb15'} w100`}>
          <Field type="radio" name={`job_application.screening_answers_attributes.${question_index}.options`} id={`question-${question.id}-option-${question_option_index}`}
            onChange={(event) => {
              let options = [question_option.id]
              formik.setFieldValue(`job_application.screening_answers_attributes.${question_index}.options`, [...options])
            }}
            checked={formik.values.job_application.screening_answers_attributes[question_index].options.includes(question_option.id)}
          />
          <span className="WrapperRadiocheckmark m0"></span> <span className={`ml0`}>{question_option.option}</span>
        </label>
      )}
      <AutocompleteError
        name={`job_application.screening_answers_attributes.${question_index}.options`}
        errorClass={PageStyle.Form__Error}
        formik={formik}
        style={InputError(formik, `job_application.screening_answers_attributes.${question_index}.options`)}
        custom_error_90={'custom_error_90'}
        custom_class  = {"form_custom_error"}
      />
    </div>
    break;
  case QUESTION_TYPES.SINGLE_CHOICE:
    return <div className={`ViewJobRadio WrapperRadio w100 align-items-start flex-column`}>
    {question.question_options_attributes.map((question_option, question_option_index) => {
      return <label className={`Dpflex WrapperRadioContainer WrapperRadiocheckmarkfont ${question_option_index == last_index ? 'mb0' : 'mb15'} w100`}>
        <Field type="radio" name={`job_application.screening_answers_attributes.${question_index}.options`} id={`question-${question.id}-option-${question_option_index}`}
          onChange={(event) => {
            let options = [question_option.id]
            formik.setFieldValue(`job_application.screening_answers_attributes.${question_index}.options`, [...options])
          }}
          checked={formik.values.job_application.screening_answers_attributes[question_index].options.includes(question_option.id)}
        />
        <span className="WrapperRadiocheckmark m0"></span> <span className={`ml0`}>{question_option.option}</span>
      </label>
    }
    )}
    <AutocompleteError
      name={`job_application.screening_answers_attributes.${question_index}.options`}
      errorClass={PageStyle.Form__Error}
      formik={formik}
      style={InputError(formik, `job_application.screening_answers_attributes.${question_index}.options`)}
      custom_error_90={'custom_error_90'}
      custom_class  = {"form_custom_error"}
    />
    </div>
    break;
  case QUESTION_TYPES.MULTIPLE_CHOICE:
      return <>
       { question.question_options_attributes.map((question_option, question_option_index) => {
       return <span className={`Dpflex ${NewPageStyle.Form__CheckLabel} ${question_option_index == last_index ? 'mb0' : 'mb15'}`}>
        <Checkbox className={`mr10`} id={`question-${question.id}-option-${question_option_index}`}
          checked = {formik.values.job_application.screening_answers_attributes[question_index].options.includes(question_option.id) || false}
          value = {formik.values.job_application.screening_answers_attributes[question_index].options}
          onChange={(event) => {
            let options = formik.values.job_application.screening_answers_attributes[question_index].options
            if(event.target.checked){
              options.push(question_option.id)
            }
            else{
              let itemIndex = options.indexOf(question_option.id)
              options.splice(itemIndex, 1)
            }
            console.log(options)
          formik.setFieldValue(`job_application.screening_answers_attributes.${question_index}.options`, [...options])
        }}
        />
        {question_option.option}
      </span>
      })}
      <AutocompleteError
        name={`job_application.screening_answers_attributes.${question_index}.options`}
        errorClass={PageStyle.Form__Error}
        formik={formik}
        style={InputError(formik, `job_application.screening_answers_attributes.${question_index}.options`)}
        custom_error_90={'custom_error_90'}
        custom_class  = {"form_custom_error"}
      />
      </>
    break;
  }
}

function setClientFontcolor(job){
  const style = {}
  if (job.client_primary_color){
    style.color = job.client_primary_color
  }else{
    style.color = "#00325A"
  }
  return style
}
// console.log(formRef.current?.values)

return (
<>
<Head>
  <meta property="og:type" content="article" />
  {job.title && <meta property="og:title"  content={job.title} key="title" /> }
  {job.client_name && <meta property="og:description" content={job.client_name} key="description" />}
  {/* {job.client_logo && <meta property="og:image" content={job.client_logo} key="image" />} */}
  {job.client_logo && <meta property="og:image" content={job.client_logo} key="image" />}
  {job.client_logo && <meta name="image" property="og:image" content={job.client_logo}/>}
  {job.client_logo && <meta name="image" property="twitter:image" content={job.client_logo}/>}
</Head>
<div className={`ViewJob ${NewPageStyle.ViewJob}`} style={displayStyle(documentLoaded)}>
  <Header
    formik={{values: header_values}}
    customizeCareerAction={customizeCareerAction}
    isPreview={true}
    isPublic={true}
    headerClass={`${NewPageStyle.ApplyJob__Header} ApplyJobHeader`}
    logoClass={`ApplyJobLogo`}
  />
  <div className = {`${NewPageStyle.ViewJob__SubHeader}`}>
    <div className = {`${NewPageStyle.ViewJob__SubHeader__Text} ${job?.career_page?.id ? '' : 'cursor-nodrop'}`}>
      <a className={job?.career_page?.id ? '' : 'text-disabled'} href = '#' onClick={() => {
        job?.career_page?.id ? redirectToCarrerPage(job.client_slug, router.query.isFrame) : ''
      }}>{job?.career_page?.id ? <img src = "/icons/apply-job/back.png"></img> : <img src = "/icons/apply-job/backdisable.png"></img>} {t('jobs:positions')}</a>
    </div>
  </div>
  {/* Job Content */}
  <div className={NewPageStyle.ViewJob__InnerContent}>
    <div className = {`${NewPageStyle.ViewJob__LeftContent} ${NewPageStyle.ViewJob__BlueBox__HideInMobile}`}>
        <div className = {`${NewPageStyle.ViewJob__BlueBox}`}>
            <ul>
              {job.city_country && <li><span className = {`${NewPageStyle.ViewJob__BlueBox__Icon}`}><LocationIcon/></span> <span style={setClientFontcolor(job)}>{job.city_country || '-'}</span></li>}
              {job.employment_type && <li><span className = {`${NewPageStyle.ViewJob__BlueBox__Icon}`}><TimeLineWeekIcon/></span> <span style={setClientFontcolor(job)}>{job.employment_type}</span></li>}
              {job.department && <li><span className = {`${NewPageStyle.ViewJob__BlueBox__Icon}`}><BlankSheetIcon/></span> <span style={setClientFontcolor(job)}>{job.department || '-'}</span></li>}
              {job.salary && <li><span className = {`${NewPageStyle.ViewJob__BlueBox__Icon}`}><CoinsIcon/></span> <span style={setClientFontcolor(job)}>{job.salary}</span></li>}
            </ul>
            <div className = {`${NewPageStyle.ViewJob__BlueBox__ShareJob}`}>
                <Button buttonstyle = {`${ButtonStyle.NewShareBtn} buttonWithIcon`}>{t('jobs:share_job')} <ShareIcon/></Button>
                <div className = {`${NewPageStyle.ViewJob__SocialIcons}`}>
                  <FacebookShareButton
                    url={url}
                    quote={job.title}
                    hashtag="#heartpace"
                    className = {`${NewPageStyle.ViewJob__SocialIcon}`}
                    >
                    <img src = "/icons/apply-job/facebook.png"></img>
                  </FacebookShareButton>
                  <LinkedinShareButton
                    url={url}
                    title={job.title}
                    summary={''}
                    source={"Candidly"}
                    className = {`${NewPageStyle.ViewJob__SocialIcon}`}
                  >
                    <img src = "/icons/apply-job/linkedIn.png"></img>
                  </LinkedinShareButton>
                  <TwitterShareButton
                    url={url}
                    title={job.title}
                    className = {`${NewPageStyle.ViewJob__SocialIcon}`}
                  >
                    <img src = "/icons/apply-job/twitter.png"></img>
                  </TwitterShareButton>
                </div>
            </div>
        </div>
    </div>
    <div className = {`${NewPageStyle.ViewJob__RightContent} ViewJobTabs`}>
      <Tabs selectedIndex={tabIndex}
       onSelect={(index) => {
        setTabIndex(index)
      }}>
        <TabList>
          <Tab>{t('jobs:overview')}</Tab>
          <Tab>{t('jobs:apply')}</Tab>
        </TabList>
        <div className = {`${NewPageStyle.ViewJob__MainHeading}`}>
            <h3 style={setClientFontcolor(job)}>{job.title}</h3>
        </div>
        <div style={tabIndex===0 ? {display:"block"}: {display:"none"}}>
          <div className = {`${NewPageStyle.ViewJob__w100} ${NewPageStyle.ViewJob__BlueBox__ShowInMobile} ${NewPageStyle.ViewJob__BlueBox__HideInDesktop}`}>
              <div className = {`${NewPageStyle.ViewJob__BlueBox}`}>
                  <ul>
                    <li><span className = {`${NewPageStyle.ViewJob__BlueBox__Icon}`}><img src ="/icons/apply-job/location.svg"></img></span> <span style={setClientFontcolor(job)}>{job.city_country}</span></li>
                    <li><span className = {`${NewPageStyle.ViewJob__BlueBox__Icon}`}><img src ="/icons/apply-job/timeline-week.svg"></img></span> <span style={setClientFontcolor(job)}>{job.employment_type}</span></li>
                    <li><span className = {`${NewPageStyle.ViewJob__BlueBox__Icon}`}><img src ="/icons/apply-job/blanksheets.svg"></img></span> <span style={setClientFontcolor(job)}>{job.department || '-'}</span></li>
                    <li><span className = {`${NewPageStyle.ViewJob__BlueBox__Icon}`}><img src ="/icons/apply-job/coins.svg"></img></span> <span style={setClientFontcolor(job)}>{job.salary}</span></li>
                  </ul>
                  <div className = {`${NewPageStyle.ViewJob__BlueBox__ShareJob}`}>
                      <Button buttonstyle = {`${ButtonStyle.NewShareBtn}`}>Share this job <img src ="/icons/apply-job/share.svg"></img></Button>
                      <div className = {`${NewPageStyle.ViewJob__SocialIcons}`}>
                        <FacebookShareButton
                          url={url}
                          quote={job.title}
                          hashtag="#heartpace"
                          className = {`${NewPageStyle.ViewJob__SocialIcon}`}
                          >
                          <img src = "/icons/apply-job/facebook.png"></img>
                        </FacebookShareButton>
                        <LinkedinShareButton
                          url={url}
                          title={job.title}
                          summary={''}
                          source={"Candidly"}
                          className = {`${NewPageStyle.ViewJob__SocialIcon}`}
                        >
                          <img src = "/icons/apply-job/linkedIn.png"></img>
                        </LinkedinShareButton>
                        <TwitterShareButton
                          url={url}
                          title={job.title}
                          className = {`${NewPageStyle.ViewJob__SocialIcon}`}
                        >
                          <img src = "/icons/apply-job/twitter.png"></img>
                        </TwitterShareButton>
                      </div>
                  </div>
              </div>
          </div>
          <iframe id={'iframeID'} scrolling="no" frameBorder="0" width={'100%'} srcDoc={` ${styledDescription} ${addTargetToLinks(job.description)}`}></iframe>
          <div className = {`${NewPageStyle.ViewJob__ApplyButton}`}>
            <Button buttonstyle= {`${ButtonStyle.primarybtn}`} onClick={()=> {
              setTabIndex(1)
            }} style={job.career_page.id ? {} : {}}>{t('jobs:apply_for_job')}</Button>
          </div>
        </div>
        <div style={tabIndex===1 ? {display:"block"}: {display:"none"}}>
          <div className = {`${NewPageStyle.ViewJob__UploadCV}`}>
            <div className = {`${NewPageStyle.ViewJob__UploadCV__LeftContent}`}>
                <div className = {`${NewPageStyle.ViewJob__UploadCV__Img}`}>
                    <img src = '/new-icons/conflict.svg'></img>
                </div>
                <div className = {`${NewPageStyle.ViewJob__UploadCV__Text}`}>
                    <p className = {`${NewPageStyle.ViewJob__TextUppercase}`}>{t('jobs:autofill')}</p>
                    <p className = {`${NewPageStyle.ViewJob__Description}`}>{t('jobs:save_time')}</p>
                </div>
            </div>
            <div className = {`${NewPageStyle.ViewJob__UploadCV__RightContent}`}>
              <div className = {`${NewPageStyle.ViewJob__UploadCV__UploadButton} UploadCVButton`}>
                <Button buttonstyle = {`${ButtonStyle.primarybtn}`} onClick={onClick}>{t('jobs:Upload_cv')} <img src= "/icons/apply-job/dropdown.png"></img></Button>

                <nav ref={dropdownRef} className={`dropboxmenu ${isActive ? 'active' : 'inactive'}`}>
                  <ul>
                    <li onClick={() => closeDropDown(setIsActive)}>
                      <label htmlFor='from_device'>
                        <Deviceicon /> <span>{t('jobs:from_device')}</span>
                      </label>
                      <input id='from_device' type="file" onChange={(event) => {onFileChange(event.target.files, formRef?.current, "cv", true, 'system', setCvErrorMessage, setOtherErrorMessage, setFileCount, setShowLoader, setIsDisabled)}} name="user_cv" />
                    </li>

                    <li onClick={() => closeDropDown(setIsActive)}>
                      <DropboxChooser
                        appKey={process.env.NEXT_PUBLIC_DROPBOX_API_KEY}
                        success={files => onFileChange(files, formRef?.current, "cv", true, 'dropbox', setCvErrorMessage, setOtherErrorMessage, setFileCount, setShowLoader, setIsDisabled)}
                        cancel={() => onCancel()}
                        multiselect={true}
                        extensions={[
                            EXTENSION_COMMON.PDF,
                            EXTENSION_COMMON.DOC,
                            EXTENSION_COMMON.DOCX,
                            EXTENSION_COMMON.RTF,
                            EXTENSION_COMMON.PPT
                          ]} >
                          <Dropboxicon />
                          <span>{t('jobs:from')} Dropbox</span>
                      </DropboxChooser>
                    </li>

                    {/* <li onClick={() => closeDropDown(setIsActive)}> */}
                    {/*   <GoogleChooser */}
                    {/*     clientId={process.env.NEXT_PUBLIC_GOOGLE_DRIVE_CLIENT_ID} */}
                    {/*     developerKey={process.env.NEXT_PUBLIC_GOOGLE_DRIVE_KEY} */}
                    {/*     success={files => onFileChange(files, formRef?.current, "cv", true, 'drive', setCvErrorMessage, setOtherErrorMessage, setFileCount, setShowLoader, setIsDisabled)} */}
                    {/*     multiselect={true} */}
                    {/*     navHidden={true} */}
                    {/*     authImmediate={false} */}
                    {/*     extensions={[ */}
                    {/*       EXTENSION_COMMON.PDF, */}
                    {/*       EXTENSION_COMMON.DOC, */}
                    {/*       EXTENSION_COMMON.DOCX, */}
                    {/*       EXTENSION_COMMON.RTF, */}
                    {/*       EXTENSION_COMMON.PPT */}
                    {/*     ]} */}
                    {/*   > */}
                    {/*   <Driveicon /> */}
                    {/*   <span> {t('jobs:from')} Google Drive</span> */}
                    {/*   </GoogleChooser> */}
                    {/* </li> */}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
          <div className = {`${NewPageStyle.ApplyForm}`}>
            <div className = {`${NewPageStyle.ApplyForm__Heading}`}>
                <h3>{t('jobs:personal_information')}</h3>
            </div>
            <div className = {`${NewPageStyle.ApplyForm__MainForm}`}>
              <Formik
                initialValues     =   {applyJobInitialValues(job)}
                validationSchema  =   {viewJobValidation()}
                initialErrors     =   {{}}
                onSubmit={ async (values, actions) =>  {
                    if(formState == "confirm")
                    {
                      setConfirmModal(true)
                    }
                    else
                    {
                        const errors = await handleFormSubmit(values, router, job_id, setConfirmModal, setShowLoader, source, setDuplicateEmail) ;
                        actions.setErrors(errors)
                    }
                  }
                }
                innerRef={formRef}
              >
              {(formik) => (
                <Form>
                  <div className={`${NewPageStyle.ApplyForm__Field} ${FormStyle.Form__TableCol}`}>
                    <span className={`${NewPageStyle.ApplyForm__Field__Label} ${FormStyle.Form__FloatingLabel}`} style = {InputText(formik, "job_application.first_name")}>
                      <span className={`red-color`}>*</span>&nbsp;{t('jobs:first_name')} <span className = {`${NewPageStyle.ApplyForm__Mandatory}`}></span>
                    </span>

                    <FormikControl
                      control       =   "input"
                      type          =   "text"
                      name          =   "job_application.first_name"
                      className     =   {`${NewPageStyle.ApplyForm__InputField} ${FormStyle.Form__Input}`}
                      formik        =   {formik}
                      style         =   {InputError(formik, "job_application.first_name")}
                      custom_class  =   {"form_custom_error"}
                    />
                </div>
                <div className={`${NewPageStyle.ApplyForm__Field} ${NewPageStyle.ApplyForm__MarginLeft65} ${FormStyle.Form__TableCol}`}>
                    <span className={`${NewPageStyle.ApplyForm__Field__Label} ${FormStyle.Form__FloatingLabel}`}>
                      <span className={`red-color`}>*</span>&nbsp;{t('jobs:last_name')} <span className = {`${NewPageStyle.ApplyForm__Mandatory}`}></span>
                    </span>

                    <FormikControl
                      control       =   "input"
                      type          =   "text"
                      name          =   "job_application.last_name"
                      className     =   {`${NewPageStyle.ApplyForm__InputField} ${FormStyle.Form__Input}`}
                      formik        =   {formik}
                      style         =   {InputError(formik, "job_application.last_name")}
                      custom_class  =   {"form_custom_error"}
                    />
                </div>

                <div className={`${NewPageStyle.ApplyForm__Field} ${NewPageStyle.ApplyForm__Field100} ${FormStyle.Form__TableCol}`}>
                    <span className={`${NewPageStyle.ApplyForm__Field__Label} ${FormStyle.Form__FloatingLabel}`}>
                      <span className={`red-color`}>*</span>&nbsp;{t('jobs:email')} <span className = {`${NewPageStyle.ApplyForm__Mandatory}`}></span>
                    </span>

                    <FormikControl
                      control       =   "input"
                      type          =   "text"
                      placeholder   =   "@"
                      name          =   "job_application.email"
                      className     =   {`${NewPageStyle.ApplyForm__InputField} ${FormStyle.Form__Input}`}
                      formik        =   {formik}
                      style         =   {InputError(formik, "job_application.email")}
                      custom_class  =   {"form_custom_error"}
                    />
                </div>

                <div className={`${NewPageStyle.ApplyForm__Field} ${NewPageStyle.ApplyForm__Field100} ${FormStyle.Form__TableCol} mb0`}>
                    <span className={`${NewPageStyle.ApplyForm__Field__Label} ${FormStyle.Form__FloatingLabel}`}>
                      <span className={`red-color`}>*</span>&nbsp;{t('jobs:contact_no')} <span className = {`${NewPageStyle.ApplyForm__Mandatory}`}>*</span>
                    </span>

                    <FormikControl
                      control       =   "input"
                      type          =   "text"
                      name          =   "job_application.contact_no"
                      className     =   {`${NewPageStyle.ApplyForm__InputField} ${FormStyle.Form__Input}`}
                      formik        =   {formik}
                      style         =   {InputError(formik, "job_application.contact_no")}
                      custom_class  =   {"form_custom_error"}
                    />
                </div>

                <div className = {`${NewPageStyle.ApplyForm__Heading}`}>
                  <h3>{t('jobs:profile')}</h3>
                </div>

                <div className={`${NewPageStyle.ApplyForm__Field} ${NewPageStyle.ApplyForm__Field100} ${PageStyle.Form__TableCol}`}>
                  <span className={`${NewPageStyle.ApplyForm__Field__Label} ${PageStyle.Form__FloatingLabel}`}>
                    {t('jobs:Upload_cv')} { job.without_cv ? '' : <span className = {`${NewPageStyle.ApplyForm__Mandatory}`}>*</span>}
                  </span>

                  <div className={`${NewPageStyle.ApplyForm}`}>
                      <ApplyDropzone id='upload_cv' type={'cv'} multiple={''} formik={formik} setCvErrorMessage={setCvErrorMessage} setOtherErrorMessage={setOtherErrorMessage} autofill={true} setFileCount={setFileCount} isDisabled={isDisabled} setIsDisabled={setIsDisabled} setShowLoader={setShowLoader} extensions={
                        [
                          EXTENSION_COMMON.PDF,
                          EXTENSION_COMMON.DOC,
                          EXTENSION_COMMON.DOCX,
                          EXTENSION_COMMON.RTF,
                          EXTENSION_COMMON.PPT,
                        ]
                      }/>
                  </div>

                  <p className={`${NewPageStyle.ApplyForm__DropBoxError} form_custom_error`}>
                    {(cvErrorMessage.length > 0) ?
                    <><Error /> <span>{cvErrorMessage}</span></> :
                    cvErrors(cvErrorMessage, formik.errors) ? <> <Error /> <span>{cvErrors(cvErrorMessage, formik.errors)} </span></> : ''
                    }
                  </p>
                </div>

                <div className={`${NewPageStyle.ApplyForm__Field} ${NewPageStyle.ApplyForm__Field100} ${PageStyle.Form__TableCol}`}>
                  <span className={`${NewPageStyle.ApplyForm__Field__Label} ${PageStyle.Form__FloatingLabel}`}>
                    {t('jobs:additional_file')}
                  </span>

                  <div className={PageStyle.Form__DropBox}>
                    <div className={PageStyle.Form__DropBoxcontainer}>
                      <ApplyDropzone id='upload_others' type={'other'} multiple={'multiple'} formik={formik} setCvErrorMessage={setCvErrorMessage} setOtherErrorMessage={setOtherErrorMessage} autofill={false} setFileCount={setFileCount} isDisabled={false} setIsDisabled={setIsDisabled} setShowLoader={setShowLoader} extensions={
                        [
                          EXTENSION_COMMON.PDF,
                          EXTENSION_COMMON.DOC,
                          EXTENSION_COMMON.DOCX,
                          EXTENSION_COMMON.RTF,
                          EXTENSION_COMMON.PPT,
                          EXTENSION_COMMON.JPG,
                          EXTENSION_COMMON.JPEG,
                          EXTENSION_COMMON.PNG
                        ]
                      } />
                    </div>
                  </div>
                  {otherErrors(otherErrorMessage, formik.errors) && <p className={`${NewPageStyle.ApplyForm__DropBoxError} form_custom_error`}><Error /> <span>{otherErrors(otherErrorMessage, formik.errors)}</span></p>}
                </div>
                <div className={`${NewPageStyle.ApplyForm__Field} ${PageStyle.Form__TableCol} mb0`}>
                  <label className={`${NewPageStyle.ApplyForm__Field__Label} ${PageStyle.Form__FloatingLabel}`} style = {InputText(formik, "job_application.candidate_linkedin_url")}>
                    {t('jobs:linkedin_link')}
                  </label>

                  <FormikControl
                    control       =   "input"
                    type          =   "text"
                    name          =   "job_application.candidate_linkedin_url"
                    className     =   {`${NewPageStyle.ApplyForm__InputField} ${PageStyle.Form__Input}`}
                    formik        =   {formik}
                    style         =   {InputError(formik, "job_application.candidate_linkedin_url")}
                    custom_class  =   {"form_custom_error"}
                  />
                </div>
                <div className={`${NewPageStyle.ApplyForm__Field} ${NewPageStyle.ApplyForm__MarginLeft65} ${PageStyle.Form__TableCol} mt30-md mb0`}>
                  <span className={`${NewPageStyle.ApplyForm__Field__Label} ${PageStyle.Form__FloatingLabel}`} style = {InputText(formik, "job_application.portfolio_url")}>
                    {t('jobs:portfolio_link')}
                  </span>

                  <FormikControl
                    control       =   "input"
                    type          =   "text"
                    name          =   "job_application.portfolio_url"
                    className     =   {`${NewPageStyle.ApplyForm__InputField} ${PageStyle.Form__Input}`}
                    formik        =   {formik}
                    style         =   {InputError(formik, "job_application.portfolio_url")}
                    custom_class  =   {"form_custom_error"}
                  />
                </div>
                {/* Screening Questions Start */}
                {job.screening_questions_attributes?.length > 0 && <div className = {`${NewPageStyle.ApplyForm__Heading}`}>
                  <h3>{t('jobs:questions')}</h3>
                </div>}

                {job.screening_questions_attributes?.length > 0 && job.screening_questions_attributes.map((question, question_index) => {
                  return  <div className={`${NewPageStyle.ApplyForm__Field} ${NewPageStyle.ApplyForm__Field100}`}>
                    <span className={`${NewPageStyle.ApplyForm__Field__Label}`}>
                      {question.question}{question.mandatory && <span className = {`${NewPageStyle.ApplyForm__Mandatory}`}>*</span>}
                    </span>

                    {renderQuestions(formik, question, question_index)}

                  </div>
                })}
                {/* Screening Questions End */}

                <div className={`${NewPageStyle.ApplyForm__Agreement} ${PageStyle.Form__LabelCheck} Mui__CustomCheckbox`}>
                  <div className = {`${NewPageStyle.ApplyForm__Agreement__LeftContent}`}>
                    <Checkbox
                      name        =   "job_application.terms_accepted"
                      inputProps  =   {{ "aria-label": "Terms and Conditions" }}
                      icon        =   {<DefaultCheckbox/>}
                      checkedIcon =   {<CheckedCheckbox/>}
                      onChange    =   {(event)=> {formik.setFieldValue('job_application.terms_accepted', event.target.checked)}}
                    />
                  </div>
                  <div className = {`${NewPageStyle.ApplyForm__Agreement__RightContent}`}> <span>  {t('jobs:privacy_link_first')} {viewJobPrivacyPolicy()} {t('jobs:privacy_link_second')}
                  </span></div>
                </div>
                <AutocompleteError
                  name="job_application.terms_accepted"
                  errorClass={NewPageStyle.Form__Error}
                  formik = {formik}
                  style={InputError(formik, "job_application.terms_accepted")}
                  custom_class  =   {"form_custom_error"}
                />

                <div className = {`${NewPageStyle.ApplyForm__SubmitButton}`}>
                  <Button buttonstyle = {`${ButtonStyle.primarybtn}`} onClick={()=>{
                    // if(!validAnswers(formik)){
                    //   const customToastrAction = new CustomToastrAction();
                    //   customToastrAction.setNormalToastr('Please answer all mandatory questions', 'warning');
                    //   return;
                    // }
                    // INFO:- If the form is not valid or subit the form without touching any field on form
                    if (!formik.isValid || Object.keys(formik.touched).length == 0)
                    {
                      formik.submitForm();
                    }
                    else {
                      setCvErrorMessage('');
                      setOtherErrorMessage('');
                      setFormState('confirm')
                      formik.submitForm();
                    }
                  }}
                  style={job.career_page.id ? {} : {}}
                  >{t('jobs:submit_application')}</Button>
                </div>
                </Form>
              )}
              </Formik>
            </div>
        </div>
        </div>
      </Tabs>
    </div>
  </div>

  <Footer
    formik={{values: job.career_page}}
    customizeCareerAction={customizeCareerAction}
    isPreview={true}
    footerClass={NewPageStyle.ApplyJob__Footer}
  />
</div>


       <Congrats trigger={confirmModal}>
        <Modal
          type="confirmation"
          noOverlay = {true}
          message= {t('modal:confirmation:best_reach',{email:formRef.current?.values?.job_application?.email })}
          heading={t('jobs:submit_application')}
          closeModal={() => setConfirmModal(false)}
          btnAction={() => {
            setFormState("submit");
            formRef.current.submitForm();
          }}
          texts={{
            button1_text: t('button:close'),
            button2_text: t('button:proceed'),
          }}
        />
       </Congrats>
{/* {privacyPolicy && <PrivacyPolicyDetails setPrivacyPolicy={setPrivacyPolicy} content={job.privacy_policy} />} */}
{privacyPolicy && <Modal type="info" heading = "Privacy Policy" mdWidth = {true} case = "privacyPolicy" content={job.privacy_policy} closeModal = {() => setPrivacyPolicy(false)} texts = {{button1_text: "OK"}} />}
{showLoader && <Loading />}
{duplicateEmail.state && <DuplicateEmailModal setDuplicateEmail={setDuplicateEmail} duplicateEmail={duplicateEmail} />}
{job?.career_page?.id && documentLoaded && <GoogleFontLoader fonts={fonts} />}
</>
);
}

export async function getServerSideProps(context)
{
  const { req, res }   =  context
  const cv_token = context.query.cvl_apply
  const source = context.query.source || context.query.job_board_slug || ''
  const client_auth_cookies =  await new NextServerCookies().get_auth_cookie(req)['Authorization'];
  const currentSlug  = context.params.slug
  const result    =  await new JobCommon().viewJob(client_auth_cookies, currentSlug);
  const status_code  =  result.status || result.response.status;
  const job          =  result?.data || {}
  let candidate_details = {}
  let activeTab = 'job'
  if(cv_token){
    candidate_details  =  await new JobCommon().getCandidateCv(client_auth_cookies, cv_token);
    activeTab = 'apply'
  }
  // if(source.length > 0){
  //   activeTab = 'apply'
  // }

  if (status_code == 301){
    const currentPath = context.resolvedUrl;
    const newSlug = result.response.data.new_slug;
    const newPath = currentPath.replace(`${currentSlug}/view-job`, `${newSlug}/view-job`);
    res.writeHead(301, { Location: newPath });
    res.end();
    return { props: {} };
  }

  return {
    props: {
    job,
    candidate_details,
    activeTab,
    source,
    status_code
    },
  }
}

export default ViewJob;
